import React from 'react';
import loadable from '@loadable/component';
import { useFeatureFlags } from '../FeatureFlags';

const Lazy = loadable(
  () => import(/* webpackChunkName: "GoogleOneTapLazy" */ './GoogleOneTap'),
);

export const GoogleOneTapLazy = () => {
  const { googleOneTap } = useFeatureFlags();

  if (googleOneTap === 'on') {
    return <Lazy />;
  }

  return null;
};
